<template>
    <div>
        <div class="flex jcsb bottom8">
            <div class="flex">
                <el-date-picker style="width: 220px" class="marr4" size="mini"format="yyyy-MM-dd" value-format="yyyy-MM-dd"  v-model="searchTime" @change="dateChange" :clearable="false" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                <el-select style="width: 90px" class="marr4" v-model="vc_hpstatus" size="mini" >
                    <el-option v-for="item in stateList" :key="item.vc_name" :label="item.vc_name" :value="item.vc_name">
                    </el-option>
                </el-select>
                <el-select style="width: 145px"  class="marr4" v-model="i_spgsid" size="mini" clearable :placeholder="$t('form_please_select_a_company')" >
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-input style="width: 200px" class="marr4" clearable size="mini" placeholder="汇票编码/付款人/票据去向" v-model="vc_search">
                </el-input>
                <el-button class="mrl20" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
                <!--                <el-button class="mrl20" icon="el-icon-refresh" circle  @click="clearSearchData" size="mini"></el-button>-->

            </div>
            <div class="flex bottom8">
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="tongji">承兑报表</el-button>
            </div>
        </div>

        <el-table class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%;margin-right: 9px;margin-left: 9px">
            <el-table-column  label="序号" align="center" type="index" width="45px"></el-table-column>
            <el-table-column align="center" label="收票日期" prop="dt_sptime" width="85px" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="出票人" prop="vc_cpr" width="85px" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="到期日期" prop="dt_dqtime" width="85px" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="出票日期" prop="dt_cptime" width="85px" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="签收银行" prop="vc_qshang"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="汇票编码" prop="vc_hpcode"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="子区间" prop="vc_subcode"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="付款人" prop="vc_fkkhname"   show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="承兑行" prop="vc_dfhang"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="收票公司" prop="vc_spgsname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="汇票金额" prop="f_pay"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div style="text-align: right;font-weight: bold">{{scope.row.f_pay}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="状态" prop="vc_hpstatus"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="处理日期" prop="dt_cltime"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="票据去向" prop="vc_skkhname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" fixed="right" width="90px"  show-overflow-tooltip >
                <template slot-scope="scope">
                    <el-button  size="mini" v-if="scope.row.vc_hpstatus=='持票'" type="text" @click="detail(scope.row,'tx')">贴现</el-button>
                    <el-button  size="mini" v-if="scope.row.vc_hpstatus=='持票'" type="text" @click="detail(scope.row,'ts')">托收</el-button>

                    <!--                    <el-button  v-if="scope.row.i_khid===-1" type="text" @click="hexiao(scope.row)">核销</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="[20,50,100]"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="760px"
                    top="30"
                    height="300"
                    :title="detailTitle"
                    :visible.sync="detailDialog"
                    v-if="detailDialog"
                    :close-on-click-modal="false" @close="detailClose">
                <detail-page :data="detailData" @close="detailClose"></detail-page>
            </el-dialog>
        </div>
        <reportdialog  ref="mydialog"  ></reportdialog>
        <eDialog ref="eDialog" :activePage="activePage"></eDialog>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import DetailPage from "./DetailPage"
    import {baseerp} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog

    export default {
        name: "index",
        components: {
            DetailPage,
            eDialog,
            reportdialog,
        },
        data() {
            return {
                loading:true,
                activePage:"report/res/spread.vue",
                mid:0,
                c_type:1,
                tableHeight:0,
                baseerp:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailData:{},
                detailDialog:false,
                hxData:{},
                hxDialog:false,
                detailTitle:'',
                gsList:[],
                i_spgsid:0,
                searchTime:[],
                vc_search:'',
                vc_hpstatus:'持票',
                stateList:[{vc_name:'全部'},{vc_name:'转让'},{vc_name:'拆票'},{vc_name:'持票'},{vc_name:'贴现'},{vc_name:'托收'}],
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getDay();
            this.getCompanyList();
            this.getAcceptanceBillList();
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-150

            },
            dateChange(){
                this.startDate=this.searchTime[0]
                this.endDate=this.searchTime[1]
                this.currentPage=1;
                this.getAcceptanceBillList();
            },
            detail(item,type){
                this.detailTitle=type=='tx'?'贴现':'托收'
                this.detailData={
                    data:item,
                    type:type
                }
                this.detailDialog=true;
            },
            tongji(){
                // if(this.i_spgsid==0){
                //     this.$message.error('请先选择公司!');
                //     return;
                // }
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({
                    title:"导出",
                    parm:{
                        type:'AcceptanceBillList',
                        mid:this.$route.meta.mid,
                        arg:{

                            endDate:this.endDate,
                            startDate:this.startDate,
                            i_spgsid:this.i_spgsid,
                            vc_hpstatus:this.vc_hpstatus=='全部'?'':this.vc_hpstatus,
                        }},
                    w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },
            detailClose(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getAcceptanceBillList()
                }
                this.detailDialog=false;

            },
            gosearch(){
                this.currentPage=1
                this.getAcceptanceBillList()
            },
            clearSearchData(){
                this.i_spgsid=0;
                this.i_khid=0;
                this.i_bzid=1;
                this.i_sktype=0;
                this.vc_bank_account='';
                this.vc_search='';
                this.i_isuse=1;
                this.i_dealstatus=-1;
                this.currentPage=1;
                this.getAcceptanceBillList()
            },

            async getCompanyList(){
                let param={
                    i_type:'0,2',
                    i_mid:this.mid,
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                    this.gsList.unshift({i_id:0,vc_name:'全部公司'})
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getAcceptanceBillList(){
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    endDate:this.endDate,
                    startDate:this.startDate,
                    i_spgsid:this.i_spgsid,
                    vc_hpstatus:this.vc_hpstatus=='全部'?'':this.vc_hpstatus,
                    vc_search:this.vc_search,
                };
                let res=await API.getAcceptanceBillList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.list;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getAcceptanceBillList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getAcceptanceBillList();
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const prem=date.getMonth().toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startDate=y+'-'+m+'-'+'01';
                this.endDate=y+'-'+m+'-'+d;
                this.preMDate=y+'-'+prem+'-'+d;
                this.searchTime=[ this.startDate,this.endDate]
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        align-items: center;
        flex-wrap:wrap ;

    }
    .jcsb{
        justify-content: space-between;
    }
    .bottom8{
        margin: 8px;
    }
    .el-radio{
        margin-right: 10px;
    }
</style>